import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import St from './PrivacyPolicyScreen.module.css';

const PrivacyPolicyScreen = () => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <div className={St.page}>
      <div className={St.container}>
        {window.history.length > 1 ? (
          <button className={St.back} onClick={() => history.goBack()}>
            {t('screens.legal.back')}
          </button>
        ) : null}
        <h1>{t('screens.legal.ppSimpleTitle')}</h1>
        <p className={St.updated}>{t('screens.legal.lastUpdatedShort')}</p>

        <h2>{t('screens.legal.ppSimpleH1')}</h2>
        <p>{t('screens.legal.ppSimpleP1')}</p>

        <h2>{t('screens.legal.ppSimpleH2')}</h2>
        <p>{t('screens.legal.ppSimpleP2')}</p>

        <h2>{t('screens.legal.ppSimpleH3')}</h2>
        <p>{t('screens.legal.ppSimpleP3')}</p>

        <h2>{t('screens.legal.ppSimpleH4')}</h2>
        <p>{t('screens.legal.ppSimpleP4')}</p>

        <h2>{t('screens.legal.ppSimpleH5')}</h2>
        <p>{t('screens.legal.ppSimpleP5')}</p>

        <h2>{t('screens.legal.ppSimpleH6')}</h2>
        <p>
          {t('screens.legal.ppSimpleP6Prefix')}<a href='mailto:privacy@regure.com'>privacy@regure.com</a>{t('screens.legal.ppSimpleP6Suffix')}
        </p>

        <h2>{t('screens.legal.ppSimpleH7')}</h2>
        <p>{t('screens.legal.ppSimpleP7')}</p>

        <h2>{t('screens.legal.ppSimpleH8')}</h2>
        <p>
          {t('screens.legal.ppSimpleP8Prefix')}<a href='mailto:privacy@regure.com'>privacy@regure.com</a>{t('screens.legal.ppSimpleP8Suffix')}
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyScreen;
